export default __webpack_public_path__ + "assets/fonts/877b9231e5bb1f939daa37646dca9998.woff";